// ⚠️ AUTO-GENERATED — DO NOT EDIT MANUALLY
// Source: ./svg/IconMappings.svg — regenerate with `nx run creditflowresearch-uilib:icons-generate --write`
import BaseIcon from './BaseIcon';
import type { IIconProps } from './types';

const IconMappings = (props: IIconProps) => (
  <BaseIcon viewBox="0 0 16 16" fill="currentColor" { ...props }>
    <path d="M11.5556 8.88889H2.66667V2.66667H11.5556V0H0V11.5556H11.5556V8.88889Z" />
    <path d="M4.44444 4.44444V7.11111H13.3333V13.3333H4.44444V16H16V4.44444H4.44444Z" />
  </BaseIcon>
);

export default IconMappings;
